const intlLoginDefaultValues = {};

export default intlLoginDefaultValues;
